// import { createAuth0 } from "@auth0/auth0-vue";

import { useAccountStore } from '~/composables/account'

export default defineNuxtPlugin(async (nuxtApp) => {
  const account = useAccountStore()
  await account.init()
})
